import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-brush-icon',
  templateUrl: './bcac-brush-icon.component.html',
  styleUrls: ['./bcac-brush-icon.component.scss']
})
export class BcacBrushIconComponent implements OnInit {
  darkModeTextColor = '#EEE';
  defaultColor = '#323232'
  activeColor = '#1890ff'

  _bcacIsDarkMode: boolean = false
  _brushIconColor = this.defaultColor
  _clearIconColor = this.defaultColor
  _brushEnlargeIconColor = this.defaultColor
  _clearRestoreIconColor = this.defaultColor
  _brushCalculateIconColor = this.defaultColor

  constructor() { }

  iconType = "brush";
  @Input()
  set bcacIconType(value: string) {
    this.iconType = value;
  }

  tooltipTitle = "";
  @Input()
  set bcacTooltipTitle(value: string) {
    this.tooltipTitle = value;
  }


  @Input()
  set bcacIsDarkMode(value: boolean) {
    this._bcacIsDarkMode = value;
    this.switchColor()
  }


  isClear: boolean = false //清除还原状态
  isActive: boolean = false  //点击状态
  @Input()
  set bcacBrushClearActive(value: boolean) {  //是否可清除框选
    this.isClear = value
    this.switchColor()
  }


  //todo 切换颜色
  switchColor() {
    this._brushIconColor = this.isActive
      ? this.activeColor
      : (this._bcacIsDarkMode
        ? this.darkModeTextColor
        : this.defaultColor)

    this._clearIconColor = this.isClear
      ? this.activeColor
      : (this._bcacIsDarkMode
        ? this.darkModeTextColor
        : this.defaultColor)

    this._brushEnlargeIconColor = this._bcacIsDarkMode
      ? this.darkModeTextColor
      : this.defaultColor
    this._clearRestoreIconColor = this._bcacIsDarkMode
      ? this.darkModeTextColor
      : this.defaultColor
    this._brushCalculateIconColor = this._bcacIsDarkMode
      ? this.darkModeTextColor
      : this.defaultColor
  }

  @Output()
  bcacBrushEmit = new EventEmitter<any>();
  clickIcon() {
    this.isActive = !this.isActive
    this.switchColor()
    const param = {
      type: this.iconType,
      active: this.isActive
    }
    this.bcacBrushEmit.emit(param);
  }



  ngOnInit() {
  }



}
